import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { TextField } from '@mui/material';
import CloudUpload from '../../components/button/Cloudupload';
import {Grid} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { createcategory } from '../../slices/category';
import { creategroup } from '../../slices/group';

const style = {
  position: 'absolute',
  top: '40%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 12,
  p: 4,
};

export default function Addcategory({setLoader}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();

  const [formdata, setFormdata] = React.useState({
    name:"",
  });

  const handleValue = (e, name) => {
    setFormdata({
      ...formdata,
      [name]: e.target.value,
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formdata.name ) {
      window.alert('Please fill out all required fields.');
    } else {
      setLoader(true);
      dispatch(creategroup({...formdata}))
      .then(() => {
        setLoader(false);
        setOpen(false);
        setFormdata({name:""})
      })
      .catch(()=>{
        setLoader(false);
      })
    }

  };

  return (
    <div>
      <Button variant='contained' size='large' onClick={handleOpen}>Add Group</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <Grid container sx={{paddingBottom: 2}}>
                <Grid xs={6} sx={{textAlign:'start'}}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
            Add Group
          </Typography>
                </Grid>
                <Grid xs={6} sx={{textAlign:'end'}}>
               <CloseIcon onClick={handleClose} sx={{cursor:'pointer'}}></CloseIcon>
                </Grid>
            </Grid>
            <hr></hr>
         <div style={{marginTop: '30px'}}>
         <TextField sx={{marginBottom: 2}} fullWidth id="outlined-basic" label="Group Name" variant="outlined"
          value={formdata.name}
                onChange={(e)=>handleValue(e, 'name')}
          />
         <Button onClick={handleSubmit} size='large' sx={{marginTop: 3, width: '100%'}} variant='contained'> Submit</Button>
         </div>
        </Box>
      </Modal>
    </div>
  );
}